import { useState, useRef, useEffect } from 'react'
import { createPortal } from 'react-dom'
import { agoraCoreNew } from '../../assets/images'
import {
    IconBell,
    IconAdjustments,
    IconLogout,
    IconMenu2,
    IconThumbUp,
    IconUser,
    IconInfoSquareRounded,
    IconCircleCheck,
    IconEdit,
    IconCreditCard,
    IconRefresh,
    IconX,
} from '@tabler/icons-react'
import { Link, useNavigate } from 'react-router-dom'
import { IconLock } from '@tabler/icons-react'
import { IconPrinter } from '@tabler/icons-react'
import { useAuth } from '../../contexts/AuthContext'
import OrgSelector from '../OrgSelector'
import BasicInfoModal from '../common/BasicInfoModal'

export default function Header({ sidebarToggle, isActive }) {
    const { logout, user } = useAuth()
    const navigate = useNavigate()
    const [settingsOpen, setSettingsOpen] = useState(false)
    const [basicInfoOpen, setBasicInfoOpen] = useState(false)
    const settingsBtnRef = useRef(null)
    const popupRef = useRef(null)

    // Close popup when clicking outside
    useEffect(() => {
        function handleClickOutside(e) {
            if (
                popupRef.current && !popupRef.current.contains(e.target) &&
                settingsBtnRef.current && !settingsBtnRef.current.contains(e.target)
            ) {
                setSettingsOpen(false)
            }
        }
        document.addEventListener('mousedown', handleClickOutside)
        return () => document.removeEventListener('mousedown', handleClickOutside)
    }, [])

    const handleLogout = () => {
        logout()
        navigate('/auth-login')
    }

    const handleBasic = () => {
        setSettingsOpen(false)
        setBasicInfoOpen(true)
    }

    return (
        <>
            <div className='p-10 flex items-center justify-between md:static relative bg-primary'>
                <div className='max-w-[250px] w-full flex items-center gap-10'>
                    <button
                        aria-label='hamburger icon'
                        onClick={sidebarToggle}
                        className={`xl:hidden xl:after:hidden after:contents-[] after:fixed after:z-[4] after:w-full after:h-full after:left-0 after:top-0 after:bg-bg-transparent after:backdrop-blur-[5px] after:transition-all after:duration-500 after:ease-in-out ${isActive ? 'after:opacity-100 after:visible after:overflow-auto' : 'after:opacity-0 after:invisible after:overflow-hidden'}`}
                    >
                        <IconMenu2 className="text-white" />
                    </button>
                    <Link to="/dashboard">
                        <img src={agoraCoreNew} alt='company logo' className='company-logo h-[40px] w-auto object-contain' />
                    </Link>
                </div>

                <div className='flex-1 flex items-center xl:justify-between justify-end gap-15 px-10'>
                    <div className='relative w-full max-w-[221px] md:block hidden' />

                    <div className='flex items-center justify-between lg:gap-30 gap-20'>
                        <OrgSelector />

                        {/* Notifications bell */}
                        {/* <div className='flex group md:relative md:after:block after:hidden after:absolute after:w-full md:after:h-[19px] after:h-[12px] after:left-0 after:right-0 after:top-full'>
                            <button aria-label="notifications" className='relative'>
                                <IconBell className="w-[22px] h-[22px] stroke-[1.5] text-text-primary transition-all duration-300 hover:text-primary" />
                                <span className="flex absolute w-10 h-10 top-[-1px] right-[-1px] border-2 border-bg-dark rounded-full">
                                    <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-text-primary opacity-75"></span>
                                    <span className="relative inline-flex rounded-full w-[6px] h-[6px] bg-text-primary"></span>
                                </span>
                            </button>
                            <div className='absolute right-0 left-auto z-[1] md:top-30 top-[23px] md:w-[500px] w-[calc(100%-20px)] md:mx-0 mx-10 border border-border bg-bg-dark shadow-light rounded-lg md:p-20 p-15 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all md:group-hover:top-40 group-hover:top-full'>
                                <div className='pb-15 text-[16px]/[24px] font-bold border-b border-border'>
                                    You have 4 new Notifications
                                </div>
                                <div className='mb-15'>
                                    <Link to="#" className='flex gap-15 py-3 px-2 border-b border-border bg-transparent transition-all duration-300 hover:bg-bg-light'>
                                        <IconThumbUp className='text-success min-w-[24px] min-h-[24px]' />
                                        <div>
                                            <p>Campaign <strong>Holiday Sale</strong> is nearly reach budget limit.</p>
                                            <p className='text-text-secondary text-[13px]'>10:00 AM Today</p>
                                        </div>
                                    </Link>
                                    <Link to="#" className='flex gap-15 py-3 px-2 border-b border-border bg-transparent transition-all duration-300 hover:bg-bg-light'>
                                        <IconUser className='text-yellow min-w-[24px] min-h-[24px]' />
                                        <div>
                                            <p>Your New Campaign <strong>Holiday Sale</strong> is approved.</p>
                                            <p className='text-text-secondary text-[13px]'>11:30 AM Today</p>
                                        </div>
                                    </Link>
                                    <Link to="#" className='flex gap-15 py-3 px-2 border-b border-border bg-transparent transition-all duration-300 hover:bg-bg-light'>
                                        <IconInfoSquareRounded className='text-danger min-w-[24px] min-h-[24px]' />
                                        <div>
                                            <p>Website visits from Twitter is 27% higher than last week.</p>
                                            <p className='text-text-secondary text-[13px]'>04:00 PM Today</p>
                                        </div>
                                    </Link>
                                    <Link to="#" className='flex gap-15 py-3 px-2 border-b border-border bg-transparent transition-all duration-300 hover:bg-bg-light'>
                                        <IconCircleCheck className='text-sky min-w-[24px] min-h-[24px]' />
                                        <div>
                                            <p>Error on website analytics configurations</p>
                                            <p className='text-text-secondary text-[13px]'>Yesterday</p>
                                        </div>
                                    </Link>
                                </div>
                                <div>
                                    <Link to="#" className='text-blue transition-all duration-300 hover:text-blue-100'>
                                        See all notifications
                                    </Link>
                                </div>
                            </div>
                        </div> */}

                        {/* Settings gear button */}
                        {/* <button
                            ref={settingsBtnRef}
                            aria-label="settings"
                            onClick={() => setSettingsOpen(prev => !prev)}
                            className='relative'
                        >
                            <IconAdjustments className="w-[22px] h-[22px] stroke-[1.5] text-text-primary transition-all duration-300 hover:text-primary" />
                        </button> */}

                        {/* Logout button */}
                        <button
                            aria-label="logout"
                            onClick={handleLogout}
                            title={`Logout ${user?.name || ''}`}
                            className='relative'
                        >
                            <IconLogout className="w-[22px] h-[22px] stroke-[1.5] text-white transition-all duration-300 hover:text-white/70" />
                        </button>
                    </div>
                </div>
            </div>

            {/* Settings popup — portal to document.body, outside all stacking contexts */}
            {settingsOpen && createPortal(
                <div
                    ref={popupRef}
                    className="fixed top-[60px] right-[16px] w-[260px] bg-primary text-white rounded-xl shadow-2xl border border-white/10 overflow-hidden"
                    style={{ zIndex: 99997 }}
                >
                    {/* Header */}
                    <div className="flex items-center justify-between px-16 py-12 border-b border-white/10">
                        <span className="text-[11px] font-bold uppercase tracking-widest text-white/60">Settings</span>
                        <button
                            onClick={() => setSettingsOpen(false)}
                            className="p-4 rounded hover:bg-white/10 text-white/60 hover:text-white transition-colors"
                        >
                            <IconX size={14} />
                        </button>
                    </div>

                    {/* Account section */}
                    <div className="px-16 py-12 border-b border-white/10">
                        <p className="text-[10px] font-bold uppercase tracking-widest text-white/50 mb-10">Account</p>
                        <div className="flex flex-col gap-2">
                            <button
                                type="button"
                                onClick={handleBasic}
                                className="flex items-center gap-12 px-10 py-8 rounded-lg hover:bg-white/10 transition-colors text-left w-full"
                            >
                                <IconEdit size={16} className="shrink-0" />
                                <span className="text-sm font-medium">Basic Information</span>
                            </button>
                            <button
                                type="button"
                                className="flex items-center gap-12 px-10 py-8 rounded-lg hover:bg-white/10 transition-colors text-left w-full"
                            >
                                <IconAdjustments size={16} className="shrink-0" />
                                <span className="text-sm font-medium">Preferences</span>
                            </button>
                            <button
                                type="button"
                                className="flex items-center gap-12 px-10 py-8 rounded-lg hover:bg-white/10 transition-colors text-left w-full"
                            >
                                <IconLock size={16} className="shrink-0" />
                                <span className="text-sm font-medium">Privacy</span>
                            </button>
                            <button
                                type="button"
                                className="flex items-center gap-12 px-10 py-8 rounded-lg hover:bg-white/10 transition-colors text-left w-full"
                            >
                                <IconBell size={16} className="shrink-0" />
                                <span className="text-sm font-medium">Notifications</span>
                            </button>
                        </div>
                    </div>

                    {/* Billing section */}
                    <div className="px-16 py-12 border-b border-white/10">
                        <p className="text-[10px] font-bold uppercase tracking-widest text-white/50 mb-10">Billing</p>
                        <div className="flex flex-col gap-2">
                            <button
                                type="button"
                                className="flex items-center gap-12 px-10 py-8 rounded-lg hover:bg-white/10 transition-colors text-left w-full"
                            >
                                <IconCreditCard size={16} className="shrink-0" />
                                <span className="text-sm font-medium">Payments</span>
                            </button>
                            <button
                                type="button"
                                className="flex items-center gap-12 px-10 py-8 rounded-lg hover:bg-white/10 transition-colors text-left w-full"
                            >
                                <IconPrinter size={16} className="shrink-0" />
                                <span className="text-sm font-medium">Invoices</span>
                            </button>
                            <button
                                type="button"
                                className="flex items-center gap-12 px-10 py-8 rounded-lg hover:bg-white/10 transition-colors text-left w-full"
                            >
                                <IconRefresh size={16} className="shrink-0" />
                                <span className="text-sm font-medium">Renewals</span>
                            </button>
                        </div>
                    </div>

                    {/* Logout */}
                    <div className="px-16 py-12">
                        <button
                            type="button"
                            onClick={handleLogout}
                            className="flex items-center gap-12 px-10 py-8 rounded-lg hover:bg-red-500/20 transition-colors text-left w-full text-red-300 hover:text-red-200"
                        >
                            <IconLogout size={16} className="shrink-0" />
                            <span className="text-sm font-medium">Logout</span>
                        </button>
                    </div>
                </div>,
                document.body
            )}

            {/* Basic Info Modal */}
            <BasicInfoModal isOpen={basicInfoOpen} onClose={() => setBasicInfoOpen(false)} />
        </>
    )
}
